var _path, _path2, _circle, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFeaIconOne(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 166,
    viewBox: "0 0 153 166",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M116.333 149.667H23C11.9543 149.667 3 140.712 3 129.667V44.9048V34.5599C3 23.5142 11.9543 14.5599 23 14.5599H39.036H97.4144H116.333C127.379 14.5599 136.333 23.5142 136.333 34.5599V44.9048V129.667C136.333 140.712 127.379 149.667 116.333 149.667Z",
    fill: "#F9A749"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M97.4144 14.5599H116.333C127.379 14.5599 136.333 23.5142 136.333 34.5599V44.9048M97.4144 14.5599V3M97.4144 14.5599V32.6223M97.4144 14.5599H39.036M39.036 14.5599H23C11.9543 14.5599 3 23.5142 3 34.5599V44.9048M39.036 14.5599V3M39.036 14.5599V32.6223M3 44.9048V129.667C3 140.712 11.9543 149.667 23 149.667H116.333C127.379 149.667 136.333 140.712 136.333 129.667V44.9048M3 44.9048H136.333M33.2703 86.087H97.4144M31.8288 109.929H76.5135",
    stroke: "#191B45",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 118,
    cy: 131,
    r: 34.5,
    fill: "#191B45",
    stroke: "#191B45"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M106 129.815L113.797 138.333L129.333 125",
    stroke: "white",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaIconOne);
export default __webpack_public_path__ + "static/media/fea_icon_one.ba791fca6782ea4a3e032e8cfe31c995.svg";
export { ForwardRef as ReactComponent };